import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames/bind";
import { SearchBlack, List } from "../../../../components/Icons/Icons";
import { InputTextBox, Loading, Pagination, Toast } from "../../../../components";
import styles from "./User.module.css";
import axiosClient from "../../../../services/axiosClient";
import { sorterArray } from "../../../../utils";
import NameCol from "../../../../components/NameCol";

const cx = classNames.bind(styles);
const User = ({ setUserCode, setCompanyCode, refresh}) => {
  const [isRefresh, setIsRefresh] = useState(false);
  const [input, setInput] = useState();
  const [textSearch, setTextSearch] = useState();
  const [check, setCheck] = useState({});
  const [count, setCount] = useState(0);
  const [data, setData] = useState();
  const [toggleSort, setToggleSort] = useState(false);
  const [dataTable, setDataTable] = useState();
  const [method, setMethod] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const ref = useRef();

  const onChangeTextSearch = (data) => {
    setInput(data);
    setCurrentPage(1);
    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      setTextSearch(data);
      setIsRefresh(!isRefresh);
    }, 300);
  };
  const handleCheckUser = (e, user) => {
    const { checked, name } = e.target;
    if (count < 1 && checked) {
      setCheck({ ...check, [name]: checked });
      if (checked) {
        setCount(count + 1);
        setUserCode(user.USERNAME);
        setCompanyCode(user.COMPANY_CODE);
      }
    } else if (count === 1 && !checked) {
      setCheck({ ...check, [name]: checked });
      setCount(count - 1);
      setUserCode("");
      setCompanyCode();
    } else {
      Toast.open("Bạn đã chọn một người dùng", "danger");
    }
  };
  useEffect(() => {
    async function getAllUser() {
      const params =
        sessionStorage.getItem("company_code") === "DEFAULT"
          ? {
            page: currentPage,
            size: 10,
            name: textSearch,
            isRefresh: isRefresh,
            status_code: 1,
          }
          : {
            page: currentPage,
            size: 10,
            name: textSearch,
            isRefresh: isRefresh,
            status_code: 1,
            company_code: sessionStorage.getItem("company_code"),
          };
          setIsLoading(true)
      try {
        const res = await axiosClient.get("/userManagement/get-list-user/", {
          params: { ...params },
        });
        const page = Math.ceil(res.count / 10)
        setPages(page)
        setData(res.data)
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
      }
    }
    getAllUser()
  }, [textSearch, isRefresh, currentPage, refresh]);

  useEffect(() => {
    const newData = data ? [...data] : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData)
          break;
      }
    } else {
      setDataTable(newData)
    }
  }, [data, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }

  const handleChosePage = (data) => {
    setCurrentPage(data)
  }
  const handleNext = () => {
    setCurrentPage(currentPage + 1)
  }
  const handlePrevious = () => {
    setCurrentPage(currentPage - 1)
  }

  return (
    <div>
      <div className={cx("content")}>
        <div className={cx("search")}>
          <div className={cx("title-list")}>
            <List />
            <p>Danh sách người dùng</p>
          </div>
          <div className={cx("search-form")}>
            <InputTextBox
              style={{ paddingTop: 2 }}
              type="text"
              placeholder="Tìm kiếm tên người dùng"
              className={cx("pd")}
              onChange={onChangeTextSearch}
              value={input}
            />
            <span className={cx("icon-search")}>
              <SearchBlack />
            </span>
          </div>
        </div>
        <div className={cx("data")}>
          <table className={cx("table")}>
            <thead>
              <tr>
                <th>STT</th>
                <th>
                  <NameCol active={method} title={'Tên người dùng'} handleSort={handleSort} method={'USERNAME'} />
                </th>
                <th>
                  <NameCol active={method} title={'Công ty'} handleSort={handleSort} method={'COMPANY_NAME'} />
                </th>
                <th>
                  <NameCol active={method} title={'Tên quyền'} handleSort={handleSort} method={'STAFF_POSITION_NAME'} />
                </th>
                <th>
                  <NameCol active={method} title={'Số camera quản lý'} handleSort={handleSort} method={'COUNT_CAM'} />
                </th>
                <th>
                  <span className={cx('options')} style={{ marginRight: '7px' }}>Chọn</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <>
                  <Loading />
                </>
              ) : (
                <>
                  {dataTable &&
                dataTable?.length > 0 &&
                dataTable?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item?.NAME}</td>
                      <td>{item.COMPANY_NAME}</td>
                      <td>{item.USERTYPE_NAME}</td>
                      <td>{item.COUNT_CAM}</td>
                      <td style={{ textAlign: "center" }}>
                        <input
                          name={item.CODE}
                          onChange={(e) => handleCheckUser(e, item)}
                          type="checkbox"
                          checked={
                            check[`${item.CODE}`]
                              ? check[`${item.CODE}`]
                              : false
                          }
                        />
                      </td>
                    </tr>
                  );
                })}
                </>
              )}
            </tbody>
          </table>
          <div className={cx('pagination')}>
            {dataTable?.length > 0 && (
              <Pagination 
              pages={pages}
              currentPage={currentPage}
              onClick={(data) => handleChosePage(data)}
              onNext={handleNext}
              onPrevious={handlePrevious}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default User;
